import React, { useState } from 'react';
import cn from 'classnames';
import { Edit2 } from 'react-feather';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { useToggle } from 'hooks';
import { Button } from 'ui';

const COLUMN_CHARACTER_COUNT = 500;
const Description = ({ lesson, setLesson }) => {
  const [isEditing, toggleIsEditing] = useToggle();
  const [description, setDescription] = useState(
    lesson.description ? lesson.description : '',
  );
  const characterCount = description?.length || 0;
  const preventLineBreaks = e => {
    if (e.key === 'Enter') e.preventDefault();
  };
  const isArchived = lesson.archivedAt !== null;
  const editDescription = () => {
    request
      .put(routes.LESSON(lesson.id), {
        lesson: {
          description,
        },
      })
      .then(() => {
        setLesson({ ...lesson, description });
      })
      .catch(error => {
        setDescription(lesson.description ? lesson.description : '');
        console.error(error);
      });
  };

  const handleInputChange = e => {
    let { value } = e.target;
    value = value.replace(/\r?\n|\r/g, ' ');
    setDescription(value);
  };

  return (
    <div className="d-f fd-c mt-40">
      <div className="d-f ai-c mb-4">
        <span className="fw-b lh-24 fz-16 c-brand-night">
          {t('lesson_overview.description')}
        </span>
        {lesson.permissions.canEditContent && !isEditing && !isArchived && (
          <button
            type="button"
            onClick={toggleIsEditing}
            className="d-f border-0 bs-n bg-inherit"
          >
            <Edit2 className="c-midnight-50" size={16} />
          </button>
        )}
        {isEditing && !isArchived && (
          <>
            <Button
              type="button"
              onClick={() => {
                toggleIsEditing();
                setDescription(lesson.description ? lesson.description : '');
              }}
              className="ml-8 d-f border-0 bs-n"
            >
              {t('lesson_overview.cancel_button')}
            </Button>
            <Button
              type="button"
              onClick={() => {
                toggleIsEditing();
                editDescription();
              }}
              customColor
              className="ml-8 d-f border-0 bs-n"
            >
              {t('lesson_overview.submit_button')}
            </Button>
          </>
        )}
      </div>
      {isEditing && (
        <textarea
          id="AssignModal-messageInput"
          className="minh-150 AssignModal-messageInput"
          value={description}
          onKeyDown={preventLineBreaks}
          onChange={handleInputChange}
        />
      )}
      {!isEditing && (
        <div
          className={cn('text-wrap', {
            'LessonOverviewLayout-columns':
              characterCount > COLUMN_CHARACTER_COUNT,
            'w-half': characterCount <= COLUMN_CHARACTER_COUNT,
          })}
        >
          {description || t('lesson_overview.description_empty')}
        </div>
      )}
    </div>
  );
};
export default props => <Description {...props} />;
